export const MAX_SANTANDER_RESTAURANT_CAPACITY = 700;